const STORAGE_KEY = "pc_theme";
export const themeStore = $state({ mode: "system", resolved: "light" });
function prefersDark() {
  try {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  } catch {
    return false;
  }
}
function readStored(fallback) {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === "light" || v === "dark" || v === "system") return v;
  } catch {
  }
  return fallback;
}
function apply() {
  const dark = themeStore.mode === "dark" || themeStore.mode === "system" && prefersDark();
  themeStore.resolved = dark ? "dark" : "light";
  try {
    document.documentElement.classList.toggle("dark", dark);
  } catch {
  }
}
export function setTheme(mode) {
  themeStore.mode = mode;
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
  }
  apply();
}
export function toggleTheme() {
  setTheme(themeStore.resolved === "dark" ? "light" : "dark");
}
export function initTheme(fallback = "system") {
  themeStore.mode = readStored(fallback);
  apply();
  try {
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
      if (themeStore.mode === "system") apply();
    });
  } catch {
  }
}
